var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "url(#paint0_linear_355_451)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6167 36.6667C23.9 36.6667 23.3334 36.1 23.3334 35.3834V31.5334C23.3334 27.0167 27.0167 23.3334 31.5334 23.3334H35.3834C36.1 23.3334 36.6667 23.9 36.6667 24.6167C36.6667 25.3334 36.1 25.9 35.3834 25.9H31.5334C28.4167 25.9 25.9 28.4334 25.9 31.5334V35.3834C25.9 36.1 25.3167 36.6667 24.6167 36.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3833 36.6667C54.6833 36.6667 54.1 36.1 54.1 35.3834V31.5334C54.1 28.4167 51.5666 25.9 48.4666 25.9H44.6166C43.9 25.9 43.3333 25.3167 43.3333 24.6167C43.3333 23.9167 43.9 23.3334 44.6166 23.3334H48.4666C52.9833 23.3334 56.6666 27.0167 56.6666 31.5334V35.3834C56.6666 36.1 56.1 36.6667 55.3833 36.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4666 56.6667H46.15C45.45 56.6667 44.8666 56.1 44.8666 55.3834C44.8666 54.6834 45.4333 54.1 46.15 54.1H48.4666C51.5833 54.1 54.1 51.5667 54.1 48.4667V46.1667C54.1 45.4667 54.6666 44.8834 55.3833 44.8834C56.0833 44.8834 56.6666 45.45 56.6666 46.1667V48.4667C56.6666 52.9834 52.9833 56.6667 48.4666 56.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3834 56.6667H31.5334C27.0167 56.6667 23.3334 52.9834 23.3334 48.4667V44.6167C23.3334 43.9 23.9 43.3334 24.6167 43.3334C25.3334 43.3334 25.9 43.9 25.9 44.6167V48.4667C25.9 51.5834 28.4334 54.1 31.5334 54.1H35.3834C36.0834 54.1 36.6667 54.6667 36.6667 55.3834C36.6667 56.1 36.1 56.6667 35.3834 56.6667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7666 38.7167H48.5H31.5H29.2333C28.5166 38.7167 27.95 39.3 27.95 40C27.95 40.7 28.5166 41.2834 29.2333 41.2834H31.5H48.5H50.7666C51.4833 41.2834 52.0499 40.7 52.0499 40C52.0499 39.3 51.4833 38.7167 50.7666 38.7167Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 43.2334V43.7834C31.5 46.55 33.7333 48.7834 36.5 48.7834H43.5C46.2667 48.7834 48.5 46.55 48.5 43.7834V43.2334C48.5 43.0334 48.35 42.8834 48.15 42.8834H31.85C31.65 42.8834 31.5 43.0334 31.5 43.2334Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 36.7667V36.2167C31.5 33.45 33.7333 31.2167 36.5 31.2167H43.5C46.2667 31.2167 48.5 33.45 48.5 36.2167V36.7667C48.5 36.9667 48.35 37.1167 48.15 37.1167H31.85C31.65 37.1167 31.5 36.9667 31.5 36.7667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_451",
    x1: -9.5,
    y1: 83,
    x2: 49.9974,
    y2: -15.1554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501045,
    stopColor: "#279B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C87F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScan);
export default __webpack_public_path__ + "static/media/icon_scan.f9f45ba92a46f38f019b69d4226a778f.svg";
export { ForwardRef as ReactComponent };